











































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { PhaseData } from '@/models/phasedata';
import type { Trade } from '@/models/trade';
import type { Project } from '@/models/project';
import type { AppliedLesson } from '@/models/appliedlesson';
import type { User } from '@/models/user';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'PhaseWorksheet',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {},
})
export default class PhaseWorksheet extends Vue {
    @Prop() private selectedTrade: Trade;
    @Getter('project/selectedProject') private selectedProject: Project;
    @Getter('account/userInfo') private userInfo: User;

    private showWorksheetTrade(phase: PhaseData, onlyPR: boolean = false) {
        if (phase.worksheet !== undefined && phase.worksheet !== null) {
            this.$router.push({
                name: 'WorksheetView',
                query: {
                    id: phase.worksheet.id.toString(),
                    onlyPR: String(onlyPR),
                },
            });
        } else {
            this.$router.push({
                name: 'CreateWorksheetTrade',
                query: {
                    tradeId: this.selectedTrade.id + '',
                    phaseId: phase.id + '',
                },
            });
        }
    }

    private getClassHB(phaseData: PhaseData) {
        if (phaseData.worksheet === undefined) {
            return '';
        } else {
            let done = true;
            if (!phaseData.worksheet || phaseData.worksheet.applied_lessons.length === 0) {
                return '';
            }
            phaseData.worksheet.applied_lessons.forEach((appliedLesson: AppliedLesson) => {
                if (!appliedLesson.done) {
                    done = false;
                    return;
                }
            });

            return !done ? 'is-danger' : 'is-success';
        }
    }

    private getClassPR(phaseData: PhaseData) {
        if (phaseData.worksheet === undefined || phaseData.worksheet === null) {
            return '';
        } else {
            let needsCheck = false;
            let hasBeenChecked = true;
            phaseData.worksheet.applied_lessons.forEach((appliedLesson: AppliedLesson) => {
                if (appliedLesson.needscheck) {
                    needsCheck = true;
                    if (!appliedLesson.checked) {
                        hasBeenChecked = false;
                        return;
                    }
                }
            });
            return needsCheck ? (hasBeenChecked ? 'is-success' : 'is-danger') : '';
        }
    }
}
